export const ImageStorageServicesBaseUrls = {
  cloudFront: 'https://d14qv6cm1t62pm.cloudfront.net'
};

export const nxtwaveLogoImageUrl = 'programs/nxtwave-logo.svg';

export const updateCloudPathNameIconList = [nxtwaveLogoImageUrl];
